<label for="text">
  Button text:
  <input type="text" id="text" [(ngModel)]="componentData.config.text">
</label>

<div class="grid-x">
  <div class="small-12 cell">
    <input type="radio" name="type" value="url" [(ngModel)]="componentData.config.type" (ngModelChange)="buttonTypeChanged()"> URL
    <input type="radio" name="type" value="section" [(ngModel)]="componentData.config.type" (ngModelChange)="buttonTypeChanged()" /> Section
    <input type="radio" name="type" value="page" [(ngModel)]="componentData.config.type" (ngModelChange)="buttonTypeChanged()" > Page
  </div>
  @if (componentData.config.type === 'url') {
    <div class="small-12 cell">
      <label for="url">
        URL:
        <input type="text" id="url" [(ngModel)]="componentData.config.url">
      </label>
    </div>
  }

  @if (componentData.config.type !== 'url') {
    <div class="small-12 cell">
      <label for="section">
        Section:
        <select name="section" id="section" [(ngModel)]="componentData.config.section" (ngModelChange)="sectionChanged()">
          @for (section of selectedState.sections; track section; let s = $index) {
            <option
              [selected]="s === componentData.config.section"
              [ngValue]="s">
              {{getSectionName(section, s)}}
            </option>
          }
        </select>
      </label>
      <label for="page">
        Page:
        <select name="page" id="page" [(ngModel)]="componentData.config.pageNumber" [(disabled)]="pageSelectDisabled">
          @for (page of getPagesForSection(); track page; let p = $index) {
            <option
              [selected]="p === componentData.config.pageNumber"
            [ngValue]="p">{{getPageTitle(page, p)}}</option>
          }
        </select>
      </label>
    </div>
  }
</div>